import type { ValueFormatterParams } from "ag-grid-community";

export const formatNumber = (value: unknown, fractionDigits: number = 0): string => {
	const num = typeof value === 'number' ? value : Number(value ?? 0);
	if (!isFinite(num)) return '';
	return num.toLocaleString(undefined, {
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	});
};

// 소수점 자리수 고정
export const formatNumberToFixed = (value: unknown, fractionDigits: number): string => {
	if (value == null || value === '') return '';
	const num = Number(value);
	if (!isFinite(num)) return '';
	return num.toFixed(fractionDigits);
};

export const createGridNumberFormatter = (fractionDigits: number) =>
	(params: ValueFormatterParams): string => formatNumberToFixed(params.value, fractionDigits);

/** AG Grid valueFormatter — 소수점 2자리 (온도·습도 등) */
export const formatGridNumber2 = createGridNumberFormatter(2);

/** AG Grid valueFormatter — 소수점 3자리 (용수사용량 지침 · 전력량 등) */
export const formatGridNumber3 = createGridNumberFormatter(3);
